import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-groups.png";

export const Route = createFileRoute(
  "/_staff/app-integrations/$id/_$id/groups",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
